/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GeneratePdfDto
 */
export interface GeneratePdfDto {
    /**
     * The ID of the treatment plan to generate a PDF for
     * @type {string}
     * @memberof GeneratePdfDto
     */
    treatmentPlanId: string;
}

/**
 * Check if a given object implements the GeneratePdfDto interface.
 */
export function instanceOfGeneratePdfDto(value: object): value is GeneratePdfDto {
    if (!('treatmentPlanId' in value) || value['treatmentPlanId'] === undefined) return false;
    return true;
}

export function GeneratePdfDtoFromJSON(json: any): GeneratePdfDto {
    return GeneratePdfDtoFromJSONTyped(json, false);
}

export function GeneratePdfDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GeneratePdfDto {
    if (json == null) {
        return json;
    }
    return {
        
        'treatmentPlanId': json['treatmentPlanId'],
    };
}

export function GeneratePdfDtoToJSON(json: any): GeneratePdfDto {
    return GeneratePdfDtoToJSONTyped(json, false);
}

export function GeneratePdfDtoToJSONTyped(value?: GeneratePdfDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'treatmentPlanId': value['treatmentPlanId'],
    };
}

